import type { ToolSpec } from './tools';

/**
 * Item boxes (docs/DAILY_ITEMS.md): a box on the lawn is picked up like a coin, its item is held,
 * and the player fires it when they choose. Only the Daily carries them, from rules version 5. A
 * level without boxes plays exactly as before.
 */
export type ItemId = 'turbo' | 'trim';
export const ITEM_IDS: readonly ItemId[] = ['turbo', 'trim'];

export const isItemId = (value: unknown): value is ItemId =>
  typeof value === 'string' && (ITEM_IDS as readonly string[]).includes(value);

/**
 * One trimmer cut from a box: the String Trimmer at its first reach (the ring of tiles round the
 * mower), with its usual cooldown before the next cut.
 */
export const ITEM_TRIMMER: ToolSpec = {
  id: 'stringTrimmer',
  charges: 1,
  cooldownTicks: 60,
  range: 1,
  shoos: false,
  clears: [],
  trims: true,
  around: true,
};
